import React from 'react'
import Navbar from './Navbar'
import ProductCatalog from './ProductCatalog'
import Footer from './Footer'

export default function Catalouge() {
  return (
    <>
    <Navbar/>
   <ProductCatalog/>
   <Footer/>
    </>
  )
}
